import { Modal } from 'react-bootstrap'
import { useTareaComentarioForm } from '../models'
import FormTextArea from '../../../components/forms/textArea/FormTextArea'
import ListaDocumentos from './ListaDocumentos'
import { useRecuperarComentariosTareasQuery } from '../../../redux/api'
import { CargaInfo } from '../../../components/layout/CargaInfo'

type Props = {
  mostrarModal: boolean
  tareaId: string
  cerrarModal: () => void
}

const ModalTareaCompletada = ({ mostrarModal, tareaId, cerrarModal }: Props) => {
  const formComentario = useTareaComentarioForm()
  const { register } = formComentario
  const { data: tarea, isError, error, isLoading } = useRecuperarComentariosTareasQuery(tareaId)

  return (
    <Modal
      show={mostrarModal}
      onHide={() => {
        cerrarModal()
      }}
      size='lg'
      dialogClassName='modal-dialog h-800px w-750px'
      scrollable={true}
      backdrop='static'
      keyboard={true}>
      {isLoading ? (
        <CargaInfo
          mensaje='Recuperando información, por favor espera.'
          isError={isError}
          mensajeError='Ocurrió un error al recuperar los datos'
          errorApi={error}
        />
      ) : (
        <>
          <Modal.Header>
            <div className='align-items-center d-flex flex-grow-1 '>
              <h3 className='modal-tittle'>Tarea completada</h3>
              <span className='text-muted fw-lighter fs-4 ps-2 d-flex'>| {tarea?.tituloTarea}</span>
            </div>
            <button
              onClick={cerrarModal}
              className=' close btn  btn-outline-dark btn-icon btn-circle btn-sm ms-5 d-flex col-12 '>
              <i className='fa-solid fa-xmark fs-1'></i>
            </button>
          </Modal.Header>
          <Modal.Body>
            <>
              {/*
                Vista de solo lectura del cierre de tarea.
                Contrato: `useRecuperarComentariosTareasQuery` devuelve el comentario y, si aplica,
                el arreglo de reportes/evidencia asociados a la tarea completada.
              */}
              <div className='mb-6'>
                <FormTextArea
                  nombreCampo='comentarioCierre'
                  nombre='Comentario de la tarea'
                  register={register}
                  disabled={true}
                  rows={6}
                  defaultValue={tarea?.comentarioCierre}
                />
              </div>
              <label className='form-label fs-3'>Evidencia documental</label>
              <div className='my-6 mx-2'>
                {tarea?.reportes && tarea?.reportes?.length > 0 ? (
                  <ListaDocumentos files={tarea?.reportes} />
                ) : (
                  <SinDocumentos />
                )}
              </div>
            </>
          </Modal.Body>
          <Modal.Footer>
            <button
              className='btn text-hover-dark btn-cancelar'
              onClick={() => {
                cerrarModal()
              }}>
              Cerrar
            </button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  )
}

export default ModalTareaCompletada

export const SinDocumentos = () => {
  return (
    <>
      <div className='text-center'>
        <i className='fa-regular fa-file fs-1 my-2'></i>
        <p className='fs-4 fw-bold text-center my-2'>No hay archivos guardados.</p>
      </div>
    </>
  )
}
